import { render, staticRenderFns } from "./AircraftDetailSlider.vue?vue&type=template&id=46f413f8&"
import script from "./AircraftDetailSlider.vue?vue&type=script&lang=js&"
export * from "./AircraftDetailSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports